//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'


const selectore = (state) => {
    return state.superLesson
};
export const useSuperLesson = () => {
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}
